import React from 'react'

import ServiceItem from './ServiceItem';

export default function ServicesCatalog(){
    return(
        <>
            <section className="ftco-section" id="servicios">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-12 text-center heading-section mb-5">
                            <span className="subheading">Servicios</span>
                            <h2 className="mb-3">Mantenimiento Especializado</h2>
                        </div>
                    </div>
                    <div className="row">
                        <ServiceItem 
                            sIcon={"flaticon-paileria"}
                            sTitle={"Soldadura industrial"}
                            sDescription={"Trabajos de soldadura industrial en plantas mineras."}
                        />
                        <ServiceItem 
                            sIcon={"flaticon-instrumentista"}
                            sTitle={"Línea instrumentista"}
                            sDescription={"Operaciones con diagramas hidráulicos y neumáticos, programación de PLC´S, supervisión de equipos de cribado, bombeo, equipo de compresión de aire y equipo de ventilación en plantas mineras."}
                        />
                        <ServiceItem 
                            sIcon={"flaticon-electrico"}
                            sTitle={"Línea eléctrica"}
                            sDescription={"Mantenimiento eléctrico a motores eléctricos, subestaciones eléctricas, operaciones en tableros de distribución, máquinas y equipos de plantas mineras."}
                        />
                        <ServiceItem 
                            sIcon={"flaticon-mecanico"}
                            sTitle={"Línea mecánica"}
                            sDescription={"Mantenimiento y reparación de sistemas electromecánicos, hidráulicos, neumáticos, mecánicos y de control, que conforman las máquinas y equipos de plantas mineras."}
                        />
                    </div>
                </div>
            </section>
        </>
    );
}